import {Toaster, useMediaQuery} from '@cashiaApp/web-components';
import {Route, Routes} from 'react-router-dom';

import CheckoutComponent from '../pages/checkout';
import NotFound from '../pages/errors/NotFound';
import Payment from '../pages/payment';
// import PaymentStatus from '../pages/payment/pages/paymentStatus';

const AppRoutes: React.FC = () => {
  const isDesktop = useMediaQuery('(min-width: 1024px)');

  return (
    <>
      <Toaster
        richColors
        toastOptions={{}}
        position={isDesktop ? 'bottom-left' : 'top-right'}
      />
      <Routes>
        <Route index path="/" element={<CheckoutComponent />} />
        <Route
          index
          path="/link/:businessName/:reference"
          element={<Payment />}
        />
        <Route
          index
          path="/link/:businessName/:reference/card"
          element={<Payment method="card" />}
        />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
};

export default AppRoutes;
